import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { serverURL } from '../../constants';
import axios from 'axios';
import { toast } from 'react-toastify';

const AdminHead = () => {
    const navigate = useNavigate();
    const location = useLocation();

    function handleLogout() {
        sessionStorage.clear();
        toast.success('Logged out');
        navigate('/signin');
    }

    useEffect(() => {
        async function checkAdmin() {
            if (!sessionStorage.getItem('auth')) {
                navigate("/signin");
                return;
            }
            const postURL = serverURL + `/api/dashboard`;
            try {
                const response = await axios.post(postURL);
                sessionStorage.setItem('adminEmail', response.data.admin.email);
                if (response.data.admin.email !== sessionStorage.getItem('email')) {
                    navigate("/home");
                }
            } catch {
                navigate("/home");
            }
        }
        if (sessionStorage.getItem('adminEmail')) {
            if (sessionStorage.getItem('adminEmail') !== sessionStorage.getItem('email')) {
                navigate("/home");
            }
        } else {
            checkAdmin();
        }
    }, []);

    const pageTitles = {
        '/admin': 'Dashboard',
        '/users': 'Users',
        '/courses': 'Courses',
        '/paid': 'Paid Users',
        '/admins': 'Admins',
        '/contacts': 'Contacts',
        '/plans': 'Plans',
        '/editterms': 'Terms',
        '/editprivacy': 'Privacy Policy',
        '/editcancellation': 'Cancellation Policy',
        '/editrefund': 'Refund Policy',
        '/editbilling': 'Billing Policy',
        '/settings': 'Settings',
        '/guide': 'Setup Guide',
    };

    const title = pageTitles[location.pathname] || 'Admin Panel';

    return (
        <div className='flex items-center justify-between px-6 py-4 bg-white border-b border-gray-200'>
            <div>
                <p className='font-black text-xl'>{title}</p>
                <p className='text-xs text-gray-400'>Admin Panel</p>
            </div>
            <div className='flex items-center gap-3'>
                <button onClick={() => navigate('/home')} className='text-xs text-gray-400 hover:text-black border border-gray-200 px-3 py-1.5 rounded-lg'>← Back to Site</button>
                <button onClick={handleLogout} className='text-xs text-red-500 hover:text-red-700 border border-red-200 px-3 py-1.5 rounded-lg'>Logout</button>
                <div className='text-right ml-2'>
                    <p className='text-sm font-medium'>{sessionStorage.getItem('mName') || 'Admin'}</p>
                    <p className='text-xs text-gray-400'>{sessionStorage.getItem('email')}</p>
                </div>
                <div className='w-9 h-9 bg-black text-white rounded-full flex items-center justify-center font-bold text-sm'>
                    {(sessionStorage.getItem('mName') || 'A').charAt(0).toUpperCase()}
                </div>
            </div>
        </div>
    );
};

export default AdminHead;
